import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function useNewsArticle(slug) {
  const [article, setArticle] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchArticle() {
      try {
        setLoading(true)
        setError(null)

        console.log('Fetching article with slug:', slug);

        const { data, error: fetchError } = await supabase
          .from('news')
          .select('*')
          .eq('slug', slug)
          .eq('published', true)
          .single()

        console.log('Supabase response:', { data, error: fetchError });

        if (fetchError) {
          // If not found by slug, try fetching all to debug
          if (fetchError.code === 'PGRST116') {
            console.log('Article not found by slug, fetching all slugs for debugging...');
            const { data: allNews } = await supabase
              .from('news')
              .select('slug, title')
              .limit(5)
            console.log('Sample slugs in database:', allNews);
          }
          throw fetchError
        }

        if (data) {
          // Transform the data to match the existing structure
          setArticle({
            title: data.title,
            date: data.date,
            content: data.content || '',
            image: data.image ? (data.image.startsWith('http') ? data.image : process.env.PUBLIC_URL + data.image) : '',
            slug: data.slug,
            id: data.id,
            createdAt: data.created_at,
            updatedAt: data.updated_at
          })
        }
      } catch (err) {
        console.error('Error fetching article:', err)
        setError(err)
        setArticle(null)
      } finally {
        setLoading(false)
      }
    }

    if (slug) {
      fetchArticle()
    }
  }, [slug])

  return { article, loading, error }
}
